//@ts-ignore
import { DashboardLayout as DashboardLayoutService } from '@careinfo/layout';
import OverViewIcon from '../Icons/OverViewIcon';
import { Outlet } from 'react-router-dom';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
import TicketIcon from '../Icons/TicketIcon';
import SubjectIcon from '../Icons/SubjectIcon';
import NoticeIcon from '../Icons/NoticeIcon';
import { getKey } from '../helpers/sessionKey';
import WelcomeIcon from '../Icons/WelcomeIcon';

export const shouldShowWelcome = getKey('shouldShowWelcome');
export const navigation: any = [
  {
    name: 'Dashboard',
    href: '',
    icon: '',
    children: [
      ...(shouldShowWelcome === 'true' || shouldShowWelcome === null
        ? [
            {
              name: 'Welcome',
              href: '/support',
              icon: WelcomeIcon,
              activeIcon: WelcomeIcon,
            },
            {
              name: 'Overview',
              href: '/support/overview',
              icon: OverViewIcon,
              activeIcon: OverViewIcon,
            },
          ]
        : [
            {
              name: 'Overview',
              href: '/support',
              icon: OverViewIcon,
              activeIcon: OverViewIcon,
            },
          ]),
    ],
  },
  {
    name: 'Support',
    href: '',
    icon: '',
    children: [
      {
        name: 'Subject',
        href: '/support/subject',
        icon: SubjectIcon,
        activeIcon: SubjectIcon,
      },
      {
        name: 'Ticket',
        href: '/support/ticket',
        icon: TicketIcon,
        activeIcon: TicketIcon,
      },
      {
        name: 'Notice',
        href: '/support/notice',
        icon: NoticeIcon,
        activeIcon: NoticeIcon,
      },
    ],
  },
];

const DashboardLayout = () => {
  return (
    <DashboardLayoutService navigation={navigation}>
      <div className={tw` p-2 overflow-y-auto h-full`}>
        <Outlet />
      </div>
    </DashboardLayoutService>
  );
};

export default DashboardLayout;
